import { sharedRegex } from '@helpers/spread/shared-regex';
import { LiquiditySource } from '@models/liquidity-source';
import { spreadsheetConfig } from '@shared/spreadsheet/spreadsheet-config';

const defaultColumnSize = 120;

// This values should match default values for each field.
// Type is mandatory to be an exact match of one of the categories or will not display the spreadsheet
const EMPTY_ROW_DEFAULT: LiquiditySource = {
  name: null,
  mnemonic: null,
  type: null,
  calculate_group: null,
  draw_order: null,
  source_sid: 0,
  balance_sheet_account_mnemonic: null,
  balance_sheet_add_factor: null,
};

const config = {
  LIQ_SOURCES_ACCEPTED_TYPE_VALUES: ['Primary', 'Secondary', 'Tertiary'],
  // Manages the min and max length of the mnemonic
  MNEMONIC_REGEXP: sharedRegex.mnemonic,
  MNEMONIC_ACCEPTED_CHARACTERS: sharedRegex.mnemonicAcceptedCharacters,
  NAME_ACCEPTED_CHARACTERS: sharedRegex.nameAcceptedCharacters,

  EMPTY_ROW_DEFAULT,
  backColor: spreadsheetConfig.backColor, // '#F0F8FF'
  hostStyle: spreadsheetConfig.hostStyle,
  // Columns Setup
  columnsConfig: [
    // If we modify this structure, we should modify also emptyRowObject
    { name: 'name', displayName: 'Name', size: 2 * defaultColumnSize },
    { name: 'mnemonic', displayName: 'Mnemonic', size: 1.5 * defaultColumnSize },
    { name: 'type', displayName: 'Type', size: defaultColumnSize },
    { name: 'calculate_group', displayName: 'Calculate Group', size: 1.5 * defaultColumnSize },
    { name: 'draw_order', displayName: 'Draw Order', size: defaultColumnSize },
    { name: 'balance_sheet_account_mnemonic', displayName: 'Bal Sheet Account', size: defaultColumnSize },
    { name: 'balance_sheet_add_factor', displayName: 'Bal Sheet Add Factor', size: defaultColumnSize * 1.2 },
  ],
  MINIMUM_ROWS: 50,
  DEFAULT_VALUES: {
    rowHeight: 20,
    colWidth: 150,
    fieldValue: 0,
    // spreadContentByDefault: [ EMPTY_ROW_DEFAULT ],
  },
  hLeftAlignStyle: spreadsheetConfig.align.left,
  hCenterAlignStyle: spreadsheetConfig.align.center,
  hRightAlignStyle: spreadsheetConfig.align.right,
};

export const SpreadConfig = config;
